import { render, staticRenderFns } from "./ad_position_edit.vue?vue&type=template&id=2b5882ee&scoped=true"
import script from "./ad_position_edit.vue?vue&type=script&lang=js"
export * from "./ad_position_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5882ee",
  null
  
)

export default component.exports